exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-avatar-container[data-v-3bb21a6d]{display:flex;align-items:center;background-color:#3e3e3e;border-radius:60px;color:#fff;padding:.25rem;font-size:1rem}.user-avatar-container[data-v-3bb21a6d]:hover{background-color:#4b4b4b}", ""]);

// exports
